import { IApplicationState } from '../../../../../../../types/types';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getIsUserEssentialPlanOnly } from '../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';

export const checkBrandingTabAllow = (
    state: IApplicationState,
): boolean => {
    if (getIsUserEssentialPlanOnly(state)) {
        const { allowBranding } = getAuthUser(state);
        return allowBranding;
    }
    return true;
}
